import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { setClientDateFormat } from './set-client-date-format';

/**
 * The method is necessary for pre-filling the registration form
 * @param {FormGroup | FormArray} formGroup
 * @param {object} data
 */
const setDateFormat = (
  formGroup: FormGroup | FormArray,
  data: object
): void => {
  Object.keys(formGroup.controls).map((field) => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      switch (field) {
        case 'birthday':
          data[field] = setClientDateFormat(data[field]);
          break;
        case 'amount':
          data[field] = Number.parseInt(data[field]);
          break;
      }
      data ? formGroup.get(field).setValue(data[field]) : '';
      if (field === 'rulesAccepted') {
        formGroup.get('rulesAccepted').setValue(true);
      }
      if (field === 'reportAccept') {
        formGroup.get('reportAccept').setValue(true);
      }
      if (field === 'personalInfoAccept') {
        formGroup.get('personalInfoAccept').setValue(true);
      }
    } else if (control instanceof FormGroup || control instanceof FormArray) {
      setDateFormat(control, data[field]);
    }
  });
};

export default setDateFormat;
